import { render, staticRenderFns } from "./TabelaRelacionamentosPf.vue?vue&type=template&id=7e9b05b6&lang=pug"
import script from "./TabelaRelacionamentosPf.vue?vue&type=script&lang=js"
export * from "./TabelaRelacionamentosPf.vue?vue&type=script&lang=js"
import style0 from "./TabelaRelacionamentosPf.vue?vue&type=style&index=0&id=7e9b05b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports